export class GridOrderByModel {
  constructor(public fieldName: string, public ascending?: boolean) {}
}
